import BaseService from "@/services/BaseService";
import {http} from "./config"

class PosVendaService extends BaseService {
  constructor() {
    super("/v1/crm/pos-venda");
  }

  listar(data){
    const queryParams = `id=${data.id ? data.id : ''}
      &vendaId=${data.vendaId ? data.vendaId : ''}
      &cliente=${data.cliente ? data.cliente : ''}
      &funcionarioId=${data.funcionarioId ? data.funcionarioId : ''}
      &status=${data.status ? data.status : ''}
      &page=${data.page ? data.page : 1}
      &limit=${data.limit ? data.limit : ''}`

      return http.get(`/v1/crm/pos-venda?${queryParams}`)
  }

  finalizar(data){
    return http.post(`/v1/crm/pos-venda/${data.id}/finalizar`)
  }
}

export default new PosVendaService();
